import { Location } from '@angular/common';
import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@app-environments/environment';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { SubscriptionService } from '@app-services/subscription/subscription.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatAccordion } from '@angular/material/expansion';
import { homeRoute } from '@app-constants/app.constants';
import { Route } from '@angular/compiler/src/core';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  navExtras
  year
  PackageDetails: any;
  logData:any = {}
  urlData: any;
  public options: any = {
    key: environment.razorkey,
    name: '',
    description: 'Subscription',
    amount: 249, // razorpay takes amount in paisa
    prefill: {
      name: '',
      email: '', // add your email id
      "contact": ""
    },
    notes: {},
    theme: {
      color: '#3880FF'
    },
    "order_id": "",
    handler: this.paymentHandler.bind(this),
    modal: {
      ondismiss: (() => {
        this.zone.run(() => {
          let body = {
            "amount": this.PackageDetails?.packageSubscriptionDto?.[0].amount,
            "creationDate": new Date().toISOString(),
            "status": "aborted",
            "userId": this.subscriptionbillingUtility.userDetails?.userId,
            "userOrderId": this.subscriptionbillingUtility.orderId,
            "reason":'abortedbyuser'
          }
          this.SubscriptionService.paymentABortedbyUser(body).subscribe((resp) => {

          })
          // add current page routing if payment fails
          this.router.navigate(['/courses/paymentstatus'], {  state: { ...this.routeparam, status: 'fail' }})
        })
      })
    }
  };
  subscriptionbillingUtility: any = {

  };
  rzp: any;
  routeparam: any = {
  };
  trackierSource: string;
  constructor(private location: Location, private router: Router, private route: ActivatedRoute, public SubscriptionService: SubscriptionService, public spinner: NgxSpinnerService, private gAnalytics: GAnalyticsService, private zone: NgZone) {
    this.urlData = this.router.getCurrentNavigation()?.extras?.state
   }

  ngOnInit(): void {
    
    this.routeparam = localStorage.getItem('logData') ? JSON.parse(localStorage.getItem('logData')):{}
    console.log(this.urlData)
    if (!this.urlData || !Object.keys(this.urlData).length) {
      window.location.href = homeRoute
    }
    this.initFun(null);

  }
  initFun(cb: any) {
    // if (this.routeparam?.detailsEntered) {
      const routeparam = this.routeparam;
      this.trackierSource = `https://marketing.infinitylearn.com/pixel?av=612df4c302535a0b13372bab&sub1=${routeparam?.phone}&sub2=${routeparam?.email}&sub3=${routeparam?.firstName}&sub4=${routeparam?.lastName}&sub5=${routeparam?.grade}&sub6=${routeparam?.examName}`;
      var year = 0;
      var grade = this.routeparam?.grade?.toString()
      switch ( grade) {
        case '11':
          year = 2023;
          break;
        case '12':
          year = 2022;
          break;
        case '13':
          year = 2022;
          break;
        case '10':
          year = 2024;
          break;
        case '9':
          year = 2025;
          break;
      }
      let data = {
        year: year,
        examName: this.routeparam?.examName,
        packageName: this.routeparam?.grade 
      }
      this.getPackageDetails(data, cb)
    // }
  }
  razorPayWindow(routeparam) {
    let user: any = localStorage.getItem('user_details_from_server');
    // var stateName = this.subscriptionbillingUtility.states.find((val) => val.abbreviation == this.subscriptionbillingUtility.selectedState)
    user = localStorage.getItem('user_details_from_server') ? JSON.parse(user) : {}
    this.subscriptionbillingUtility.userDetails = user;

    var object = {
      "amountAfterDiscount": this.PackageDetails?.packageSubscriptionDto?.[0].amount,
      "billingAddress": {
        "address": '',//this.subscriptionbillingUtility.billingAddress ?? '',
        "email": this.routeparam?.email ?? '',
        "firstName": this.routeparam?.firstName ? this.routeparam?.firstName : this.routeparam?.firstname ? this.routeparam?.firstname : '',
        "lastName": this.routeparam?.lastName ? this.routeparam?.lastName : this.routeparam?.lastname ? this.routeparam?.lastname : '',
        "phone": this.routeparam?.phone ?? '',
        "statecode":  this.routeparam.state?.abbreviation,
        "zipcode": '',//,this.subscriptionbillingUtility.selectedPin,
        "stateName":   this.routeparam.state?.name,
      },
      "discountAmount": 0,
      "discountCode": this.subscriptionbillingUtility.discountCode ? this.subscriptionbillingUtility.discountCode : null,
      "notes": "",
      "orderAmount": this.PackageDetails?.packageSubscriptionDto?.[0].amount,
      "packageSubscriptions": [
        {
          "id": this.PackageDetails?.packageSubscriptionDto?.[0].id,
        }
      ],
      "isdCode":  this.routeparam?.isdCode??'',
      "phone": this.routeparam?.phone ?? '',
      "paymentGatewayCode": "RAZORPAY",
      "userId": this.subscriptionbillingUtility.userDetails?.userId
    }
    this.SubscriptionService.userorders(object).subscribe((resp: any) => {
      this.subscriptionbillingUtility.generatedOrderDetails = resp;
      this.options.order_id = resp?.gatewayOrderId;
      this.subscriptionbillingUtility.orderId = resp?.orderId;
      this.options.amount = object?.amountAfterDiscount * 100;//amountAfterDiscount for razor pay
      this.options.name = this.routeparam?.firstName ? this.routeparam?.firstName : this.routeparam?.firstname ? this.routeparam?.firstname : '' + ' ' + this.routeparam?.lastName ? this.routeparam?.lastName : this.routeparam?.lastname ? this.routeparam?.lastname : '';
      this.options.prefill.name = this.options.name;
      this.options.prefill.email = this.subscriptionbillingUtility?.userDetails?.email;
      this.options.prefill.contact = this.subscriptionbillingUtility.mobileNumber ? this.subscriptionbillingUtility.mobileNumber : routeparam?.phone;
      this.createOrderid()
    })
  }
  createOrderid() {
    this.rzp = new this.SubscriptionService.nativeWindow['Razorpay'](this.options);
    this.rzp.open();
    this.rzp.on('payment.failed', (response: any) => {
      let body = {
        "amount": this.PackageDetails?.packageSubscriptionDto?.[0].amount,
        "creationDate": new Date().toISOString(),
        "status": "aborted",
        "userId": this.subscriptionbillingUtility.userDetails?.userId,
        "userOrderId": this.subscriptionbillingUtility.orderId,
        "reason":response?.error?.code??'unkownissue'
      }
      this.SubscriptionService.paymentABortedbyUser(body).subscribe((resp) => {

      })
    });
  }
  paymentHandler(res: any) {
    this.zone.run(() => {
      if (res?.razorpay_signature) {
        var obj = {
          "gatewayCode": "RAZORPAY",
          "paymentMode": "ONLINE",
          "razorpayOrderId": res?.razorpay_order_id,
          "razorpayPaymentId": res?.razorpay_payment_id,
          "razorpaySignature": res?.razorpay_signature,
          "userOrderId": this.subscriptionbillingUtility.orderId,
          "batchId":  this.routeparam?.examName?.replaceAll(" ", "")?.toUpperCase()  +' '+ this.year+ ' Crash course -'  + (this.routeparam?.batchid == 1 ? 'Dec Batch' :'Nov Batch')
        }
        this.SubscriptionService.userPayment(obj,this.routeparam?.grade).subscribe((resp: any) => {
          let user = JSON.parse(localStorage.getItem('user_details_from_server'));
          this.router.navigate(['/courses/paymentstatus'], { state: { ...this.routeparam, status: 'success', ...{ payment: resp } } })
        },(res)=>{
          this.router.navigate(['/courses/paymentstatus'], {  state: { ...this.routeparam, status: 'fail' }})
        })
      }
      // add API call here
    });
  }
  getPackageDetails(packageName: any, cb: any) {
    let remanepackagename = packageName?.examName?.toLowerCase()?.indexOf('jee') !==-1 ? 'JEEMAIN' :  packageName?.examName
    var param = {
      examName: remanepackagename?.replaceAll(" ", "")?.toUpperCase()??'NEET',
      year: packageName?.year,
      producttype: 'liveclass',
      pageUrl: "studentPortal_Subscriptions",
    }
    this.year =  packageName?.year;
    let grade = this.routeparam?.grade;
    this.SubscriptionService.totalexamTypePackages(param, grade).subscribe((res: any) => {
      var packageDEtail = res.filter(x => x.productName === 'booking')
      if (packageDEtail?.length > 1) {
        var findPackagewithgrade = packageDEtail.find(val => val.name.indexOf(packageName?.grade) !== -1)
        if (findPackagewithgrade) {
          packageDEtail = [findPackagewithgrade]
        } else {
          packageDEtail = [packageDEtail?.[0]]
        }
      }
      this.PackageDetails = packageDEtail?.[0];
      if (cb) cb();
    })
  }

}
